import React, { useContext } from "react";
import { Context } from "../../Provider";

const NicLicenceVehicleDetails = () => {
    const { state } = useContext(Context);
    const { selected_ftm } = state;

    const {
        ftm_vehicle_number = "N/A",
        ftm_driving_license_number = "N/A",
    } = selected_ftm || {};

    const details = [
        { label: "Vehicle Registration", value: ftm_vehicle_number || "N/A" },
        { label: "Driving Licence Number", value: ftm_driving_license_number || "N/A" },
    ];

    return (
        <div className="col-lg-12">
            <div className="card h-100">
                <div className="card-header pb-0 p-3">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center">
                            <h6 className="mb-0">LICENCE & VEHICLE DETAILS</h6>
                        </div>
                    </div>
                </div>
                <div className="card-body p-3 pb-0">
                    <ul className="list-group">
                        {details.map((item, index) => (
                            <li
                                key={index}
                                className="list-group-item border-0 d-flex justify-content-between ps-0 pt-0 border-radius-lg"
                            >
                                <div className="d-flex flex-column">
                                    <h6 className="mb-1 text-dark font-weight-bold text-sm">
                                        {item.label}
                                    </h6>
                                </div>
                                <div className="d-flex align-items-center text-sm">
                                    {item.value}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default NicLicenceVehicleDetails;